export enum KeyCodes {
  Tab = 'Tab',
  Enter = 'Enter',
  Escape = 'Escape',
  ArrowUp = 'ArrowUp',
  ArrowLeft = 'ArrowLeft',
  ArrowDown = 'ArrowDown',
  ArrowRight = 'ArrowRight',
  Period = '.',
  Backspace = 'Backspace',
  Space = ' ',
  Zero = '0',
  Delete = 'Delete',
}
